<template>

  <div id="app" class="app">
    <div key="routerViewShow" style="  text-align: center;" v-if="$store.state.routerViewShow">
      <router-link to="/">
        <el-button type="primary" style="margin: 10px" plain>
          返回选择房间
        </el-button>
      </router-link>
      <router-link to="/home">
        <el-button style="margin: 10px" plain>
          主页
        </el-button>
      </router-link>
      <router-link key="group" to="/groupReserve" v-if="$store.state.nowRoom.group">
        <el-button style="margin: 10px">
          团体预约
        </el-button>
      </router-link>
      <span key="individual" v-if="$store.state.nowRoom.gym">
            <router-link to="/GymSelect">
            <el-button style="margin: 10px" type="success" plain>
              开始预约
            </el-button>
            </router-link>
          </span>

      <span key="individual" v-if="$store.state.nowRoom.individual">
            <router-link to="/selectBySeat">
            <el-button style="margin: 10px" type="success" plain>
              按照<span v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座位</span>选<span v-if="$store.state.nowRoom.mensetu">择</span><span v-else>座</span>
            </el-button>
            </router-link>
            <router-link to="/selectByDate">
              <el-button style="margin: 10px" type="success" plain>
                按照时间选<span v-if="$store.state.nowRoom.mensetu">面试室</span><span v-else>座</span>
              </el-button>
            </router-link>
          </span>
      <span v-if="!$store.state.nowRoom.gym">
        <router-link to="/myReserved">
        <el-button style="margin: 10px">
          我的预约
        </el-button>
      </router-link>
        </span>
      <span v-if="$store.state.nowRoom.gym">
        <router-link to="/MyReservedGym">
        <el-button style="margin: 10px">
          我的预约
        </el-button>
      </router-link>
      </span>

    </div>
    <div v-if="$store.state.nowRoom.name!==undefined" class="info">您正在预约{{ $store.state.nowRoom.name }}</div>
    <div v-if="$store.state.nowRoom.location!==undefined" class="info">位置：{{ $store.state.nowRoom.location }}</div>
    <div v-if="$store.state.nowRoom.name===undefined&&$route.path!=='/'" class="info">您还没有选择房间</div>
    <div class="info" :style="'color:'+color +';text-shadow:0 0 1px '+color">{{ announcement }}</div>

    <!--    <router-view class="rv"/>-->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>

</template>

<script>


import {ifNotWx} from "./utils/wxUtil";
import axios from '@/utils/request'

export default {
  name: 'App',

  data() {
    return {
      announcement: "",
      color: ""
    }
  },
  methods: {
    getAnnouncement() {
      axios.post("/getAnnouncement").then(res => {
        this.announcement = res.data.announcement
        this.color=res.data.color
      })
    }
  },
  mounted() {

    ifNotWx(() => {
      document.body.innerHTML = "<h1 style='text-align: center'>使用限制</h1>" +
          "<p style='text-align: center'>请在微信浏览器中打开</p>"

    })


    document.title = "选座Web"
  },
  created() {
    console.log("举办永雏塔菲谢谢喵")
    this.getAnnouncement()
  }
};
</script>

<style>
body {
  margin: 0 0 0 0;
  /*background-color: #eefcff;*/
  background-image: url("assets/20200221181049_mukyu.jpg");
  background-repeat: no-repeat;
  -moz-background-size: 100%;
  overflow: auto;
  background-attachment: fixed;
  background-size: cover;
  height: 100%;
}


</style>

<style scoped>
.app {

  margin: 8px;
}


img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-button {

}

div {
  text-align: center;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .5s;
}

.fade-leave {
  opacity: 1;
}

.fade-leave-active {
  opacity: 0;
  transition: opacity .3s;
}
</style>

<style>
.el-message-box {
  width: 325px;
}
</style>